import React from "react";
import { Outlet } from "react-router-dom";

export default function Offline() {
    return (
        <div className="offline d-flex align-items-center justify-content-center">
            <div className="w-100">
                <Outlet />
            </div>            
        </div>
    );
};